import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { FileQuestion } from "../../../../shared/components/dynamic-form/question-file";

@Injectable()
export class PartnerBulkUploadService {
  constructor() {}

  generateQuestions(): Observable<QuestionBase<string | boolean>[]> {
    const questions: QuestionBase<string | boolean>[] = [
      new FileQuestion({
        key: "csv",
        fileOptions: {
          accept: ".csv",
        },
        order: 1,
      }),
    ];

    return of(questions.filter((field) => field).sort((a, b) => a.order - b.order));
  }
}
